import { render } from "./PollStudents.vue?vue&type=template&id=feaf7c1e&scoped=true"
import script from "./PollStudents.vue?vue&type=script&lang=js"
export * from "./PollStudents.vue?vue&type=script&lang=js"

import "./PollStudents.vue?vue&type=style&index=0&id=feaf7c1e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feaf7c1e"]])

export default __exports__